import { useQuery } from "@apollo/client";
import { GET_TRENDING_STORIES } from "../graphql/stories";
import type { Story } from "../types/models";

interface TrendingStoriesData {
  trendingStories: Story[];
}

interface TrendingStoriesVariables {
  limit?: number;
}

// useTrendingStories hook - Accept limit parameter (default 10)
export const useTrendingStories = (limit = 10) => {
  const { data, loading, error } = useQuery<TrendingStoriesData, TrendingStoriesVariables>(
    GET_TRENDING_STORIES,
    {
      variables: { limit },
    }
  );

  // Filter out deleted stories as a defensive measure (backend should already filter)
  const stories = (data?.trendingStories || []).filter(
    (story) => story.isDeleted !== true
  );

  return {
    stories,
    isLoading: loading,
    error,
  };
};

